'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "AsyncMetadata", {
    enumerable: true,
    get: function() {
        return AsyncMetadata;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _react = require("react");
const _navigation = require("../../client/components/navigation");
// We need to wait for metadata on server once it's resolved, and insert into
// the HTML through `useServerInsertedHTML`. It will suspense in <head> during SSR.
function ServerInsertMetadata({ promise }) {
    let metadataToFlush = (0, _react.use)(promise);
    (0, _navigation.useServerInsertedHTML)(()=>{
        if (metadataToFlush) {
            const flushing = metadataToFlush;
            // reset to null to ensure we only flush it once
            metadataToFlush = null;
            return flushing;
        }
    });
    return null;
}
function BrowserResolvedMetadata({ promise }) {
    return (0, _react.use)(promise);
}
function AsyncMetadata({ promise }) {
    return /*#__PURE__*/ (0, _jsxruntime.jsx)(_jsxruntime.Fragment, {
        children: typeof window === 'undefined' ? /*#__PURE__*/ (0, _jsxruntime.jsx)(ServerInsertMetadata, {
            promise: promise
        }) : /*#__PURE__*/ (0, _jsxruntime.jsx)(BrowserResolvedMetadata, {
            promise: promise
        })
    });
}

//# sourceMappingURL=async-metadata.js.map